import {Injectable, isDevMode, NgZone} from '@angular/core';
import {Router} from '@angular/router';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {ErrorActions} from 'app/core/components/error-page/state/error.actions';
import {tap} from 'rxjs';

@Injectable()
export class ErrorEffects {
  directToErrorPage$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ErrorActions.directToErrorPage),
        tap(({error}) => {
          if (isDevMode()) {
            // eslint-disable-next-line no-console
            console.error(error);
          }
          this.zone.run(() => {
            this.router.navigate(['/error']);
          });
        })
      ),
    {dispatch: false}
  );

  constructor(
    private actions$: Actions,
    private router: Router,
    private zone: NgZone
  ) {}
}
